export default __webpack_public_path__ + "static/media/einvoice-white.58a6e723.svg";